import React from 'react';
import * as ReactRedux from 'react-redux';
import ReactSwipeEvents from 'react-swipe-events';
import {toast} from 'react-toastify';
import store from 'store';

import {axios, venditshop} from '../../index';
import {receiveLoadingUpdate} from '../../redux/actions';
import Clear from '../structure/helper/Clear';
import P1 from '../structure/helper/P1';

import Product from './Product';

class ProductList extends React.PureComponent {
    constructor(props) {
        super(props);
        const mobile = this.props?.mobile || false;

        this.bot = /bot|google|aolbuild|baidu|bing|msn|duckduckgo|teoma|slurp|yandex/i.test(navigator.userAgent);

        this.ref = React.createRef();
        this.focusRef = React.createRef();

        this.ppsSettings = {
            galerie: {
                wenig: 9,
                mittel: 18,
                viel: 45,
                ultra: 150
            },
            liste: {
                wenig: 10,
                mittel: 20,
                viel: 50,
                ultra: 200
            },
            tabelle: {
                wenig: 10,
                mittel: 20,
                viel: 50,
                ultra: 200
            },
            ordsatz: {
                wenig: 10,
                mittel: 20,
                viel: 50,
                ultra: 200
            },
            default: {
                wenig: 10,
                mittel: 20,
                viel: 50,
                ultra: 200
            },
            defaultNoImg: {
                wenig: 10,
                mittel: 20,
                viel: 50,
                ultra: 200
            }
        };
        // bei mobile pauschal auf 30
        if (this.props?.mobile) {
            this.ppsSettings = {
                galerie: {
                    wenig: 20,
                    mittel: 20,
                    viel: 20,
                    ultra: 20
                },
                default: {
                    wenig: 20,
                    mittel: 20,
                    viel: 20,
                    ultra: 20
                },
                defaultNoImg: {
                    wenig: 20,
                    mittel: 20,
                    viel: 20,
                    ultra: 20
                },
                ordsatz: {
                    wenig: 20,
                    mittel: 20,
                    viel: 20,
                    ultra: 20
                }
            };
        }

        let ppsSetting = this.bot || props.meta?.conf?.maxdisplay ? 'alle' : 'wenig';
        let displaytype = props.displaytype;

        const filter = 'alle';
        let sortby = 'bezeichnung';
        let sortasc = true;
        if (store.enabled && !this.bot) {
            ppsSetting = store.get('ProductList/ppsSetting') || ppsSetting;
            if (props.list && props.list.length >= 500 && ppsSetting === 'alle') {
                ppsSetting = 'ultra';
            }
            const storeDisplaytype = store.get('ProductList/displaytype');

            displaytype = props.forceDisplaytype || storeDisplaytype || displaytype;

            if (storeDisplaytype === 'ordsatz' && !props.ordersatzSpezialansicht) {
                displaytype = 'galerie';
                if (mobile) {
                    displaytype = 'default';
                }
            }

            if (props?.mobile && displaytype === 'default' && !this.props?.listId && !this.props?.uebersicht) {
                displaytype = 'galerie';
            } else if (props?.mobile && displaytype === 'galerie' && this.props?.listId) {
                displaytype = 'default';
            }

            if (mobile && (storeDisplaytype == 'liste' || storeDisplaytype == 'tabelle')) {
                // this.setDisplaytype('galerie');
                displaytype = 'galerie';
            }
            const storeSortby = store.get('ProductList/sortby');
            if (storeSortby === 'kategorie' && !props.sortByCategory) {
                sortby = 'bezeichnung';
            } else if (storeSortby === 'eigen' && !props.sortByEigen) {
                sortby = 'bezeichnung';
            } else {
                sortby = storeSortby || sortby;
            }

            if (this.props.vertriebsaktion) {
                sortby = 'vertriebsaktion_sortierschluessel';
            }
            sortasc = typeof store.get('ProductList/sortasc') === 'undefined' ? sortasc : store.get('ProductList/sortasc');

            if (this.props.bezeichnung != store.get('ProductList/id')) {
                if (props.meta?.conf?.sort?.angebote && this?.props?.promotion) {
                    sortby = props.meta?.conf?.sort?.angebote;
                } else if (props.meta?.conf?.sort?.specialoffer && this?.props?.specialoffer) {
                    sortby = props.meta?.conf?.sort?.specialoffer;
                } else if (props.meta?.conf?.sort?.promsOfTheWeek && this?.props?.promotionOfTheWeek) {
                    sortby = props.meta?.conf?.sort?.promsOfTheWeek;
                } else if (props.meta?.conf?.sort?.ordersatz && props?.listId) {
                    sortby = props.meta?.conf?.sort?.ordersatz;
                } else if (props.meta?.conf?.sort?.bestseller && this?.props?.bestseller) {
                    sortby = props.meta?.conf?.sort?.bestseller;
                } else if (props.meta?.conf?.sort?.neuheiten && this?.props?.neuheiten) {
                    sortby = props.meta?.conf?.sort?.neuheiten;
                } else if (props.meta?.conf?.sort?.sortiment) {
                    sortby = props.meta?.conf?.sort?.sortiment;
                }
                if (props.meta?.conf?.sort?.sortasc) {
                    sortasc = props.meta?.conf?.sort?.sortasc;
                }
                if (props.meta?.conf?.sort?.ansicht) {
                    displaytype = props.meta?.conf?.sort?.ansicht;
                }
            }
        }

        if (this?.props?.hausmesse && !mobile) {
            displaytype = 'liste';
            sortby = 'hausmesse';
        }

        this.state = {
            list: [],
            page: 1,
            textfilter: '',
            ppsSetting,
            displaytype,
            filter,
            sortby,
            sortasc,
            artikel: [],
            filterSelect: (this?.props?.settings?.find((e) => e.bezeichnung == 'ordersatzmobilePositionSelect')?.wert || 'grey'),
            swipingPosition: 0,
            ordersatzDisplay: 'none',
            currentSwipingArtikel: 0,
            newListName: '',
            gotoPage: false,
            toPage: '',
            didOrder: false,
            shouldhide: [],
            lastScrollTime: 0,
            lastScrollY: 0
        };

        this.changeTextfilterTimeout = 0;
        this.handleChangeTextfilter = (e) => {
            const val = e.target.value;
            this.setState({textfilter: val});
            window.clearTimeout(this.changeTextfilterTimeout);
            this.changeTextfilterTimeout = window.setTimeout(document.onscroll, 512);
        };

        this.setPpsSetting = (value) => {
            if (store.enabled && !this.bot) {
                store.set('ProductList/ppsSetting', value);
            }
            const page = this.calcPage(null, value);
            this.setState({page: page, ppsSetting: value}, document.onscroll);
        };

        this.scrollTo = (callback) => {
            let id = window.location.pathname + window.location.search;
            if (this?.props?.listId) {
                id = this?.props?.listId;
            } else if (this.props?.hrefPrefix) {
                id = this.props?.hrefPrefix;
            }

            //ordersätze
            if (this.props?.listId) {
                if (store.get(this.props?.listId + '/page')) {
                    this.setState({
                        page: store.get(this.props?.listId + '/page')
                    });
                }
                if (store.get(this.props?.listId + '/filter')) {
                    this.setState({
                        textfilter: store.get(this.props?.listId + '/filter')
                    });
                }
                if (store.get(this.props?.listId + '/pixel')) {
                    window.scrollTo(0, store.get(this.props?.listId + '/pixel'));
                }
                if (store.get(this.props?.listId + '/alphafilter')) {
                    this.setState({
                        filter: store.get(this.props?.listId + '/alphafilter')
                    });
                }
            } else if (store.enabled && !this.bot && (store.get('ProductList/id')) && id == store.get('ProductList/id')) {
                if (store.get('ProductList/page')) {
                    this.setState({
                        page: store.get('ProductList/page')
                    });
                }

                if (store.get('ProductList/filter')) {
                    this.setState({
                        textfilter: store.get('ProductList/filter')
                    });
                }
                if (store.get('ProductList/pixel')) {
                    window.scrollTo(0, store.get('ProductList/pixel'));
                }
                if (store.get('ProductList/alphafilter')) {
                    this.setState({
                        filter: store.get('ProductList/alphafilter')
                    });
                }
            } else if (this.props.bezeichnung != store.get('ProductList/id')) {
                // Falls eine andere liste aufgerufen wird Daten zurücksetzen
                store.set('ProductList/id', '');
                store.set('ProductList/page', 1);
                store.set('ProductList/filter', '');
                store.set('ProductList/pixel', 0);
                store.set('ProductList/alphafilter', 'alle');
            }
            if (callback != null && typeof callback === 'function') {
                callback();
            }
        };

        this.onScrollEvent = () => {
            const verticalThreshold = 20;
            if (this.state.lastScrollY != window.scrollY || this.state.lastScrollY + verticalThreshold < window.scrollY &&
                this.state.lastScrollY - verticalThreshold > window.scrollY) {
                this.setState({lastScrollTime: new Date().getTime(), lastScrollY: window.scrollY});
            }
            // ID versuchen zu holen, damit das nicht abkackt wenn gleiche Bezeichnung
            let id = window.location.pathname + window.location.search;

            if (this?.props?.listId) {
                id = this?.props?.listId;
            } else if (this.props?.hrefPrefix) {
                id = this.props?.hrefPrefix;
            }

            if (store.enabled && !this.bot) {
                store.set('ProductList/id', id);
                store.set('ProductList/page', this.state.page);
                store.set('ProductList/filter', this.state.textfilter);
                store.set('ProductList/alphafilter', this.state.filter);
                store.set('ProductList/pixel', window.scrollY);
                if (this.props?.listId) {
                    store.set(this.props?.listId + '/page', this.state.page);
                    store.set(this.props?.listId + '/filter', this.state.textfilter);
                    store.set(this.props?.listId + '/alphafilter', this.state.filter);
                    store.set(this.props?.listId + '/pixel', window.scrollY);
                }
            }
        };

        this.setDisplaytype = (value) => {
            if (store.enabled && !this.bot) {
                store.set('ProductList/displaytype', value);
            }
            const page = this.calcPage(value, null);
            this.setState({page: page, displaytype: value}, document.onscroll);
        };

        this.setSortby = (value, tmp = null) => {
            let sort;
            if (mobile) {
                sort = tmp === null ? this.state.sortasc : tmp;
            } else {
                sort = this.state.sortby !== value || !this.state.sortasc;
            }

            if (store.enabled && !this.bot) {
                store.set('ProductList/sortby', value);
                store.set('ProductList/sortasc', sort);
            }

            this.setState({sortby: value, sortasc: sort}, document.onscroll);
        };

        this.calcPage = (displaytype, ppsSetting) => {
            displaytype = displaytype || this.state.displaytype;
            ppsSetting = ppsSetting || this.state.ppsSetting;
            if (ppsSetting === 'alle' || this.state.ppsSetting === 'alle') {
                return 1;
            }
            const countOld = this.ppsSettings[this.state.displaytype][this.state.ppsSetting];
            const countNew = this.ppsSettings[displaytype][ppsSetting];
            return Math.floor((this.state.page * countOld - countOld) / countNew) + 1;
        };

        this.seltsame_ref_liste = {};

        if (this.props?.list && this.props?.list?.length) {
            this.props?.list?.forEach((element) => {
                this.seltsame_ref_liste[element.artikel] = React.createRef();
            });
        }

        this.saveSetting = async (value, setting) => {
            await axios.post((this.props?.meta?.conf?.cssCompletePath
                ? this.props?.meta?.hostname
                : '') + '/customer/saveSettings/', {wert: value, setting: setting});
        };
        this.swipeleft = (artikel) => {
            if (mobile) {
                // const tmp = this.state.artikel;
                this.seltsame_ref_liste[artikel]?.current?.ichWurdeNachLinksGeswiped();
                const shouldHideArray = this.state.shouldhide;
                shouldHideArray[artikel] = 'hidden-left';
                this.setState({shouldhide: shouldHideArray});
                this.forceUpdate();
                store.set('list/' + this.props?.listId + '/' + artikel + '/', 'red');
            }
        };
        this.swiperight = (artikel) => {
            if (mobile) {
                this.seltsame_ref_liste[artikel]?.current?.ichWurdeNachRechtsGeswiped();
                const shouldHideArray = this.state.shouldhide;
                shouldHideArray[artikel] = 'hidden-right';
                this.setState({shouldhide: shouldHideArray});
                this.forceUpdate();
                store.set('list/' + this.props?.listId + '/' + artikel + '/', 'green');
            }
        };

        this.orderList = async () => {
            const tmp = this.state.artikel.filter((artikel) => artikel.status === 'green');
            if (tmp === null || !tmp.length) {
                return;
            }
            this.setState({didOrder: true});
            this.props?.changeLoading(true);
            for (const artikel of tmp) {
                await this.seltsame_ref_liste[artikel.id]?.current?.ichWurdeNachRechtsGeswiped();
            }
            toast('Der Ordersatz wurde dem Warenkorb hinzugefügt!');
            window.location.href = (this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : '') + '/cart/';
            this.props?.changeLoading(true);
        };

        this.removeFromList = (artikel) => {
            this.setState({list: this.state.list.filter((a) => a.artikel !== artikel)});
        };
    }

    static defaultProps = {
        displaytype: 'galerie',
        forceDisplaytype: null,
        list: [],
        editable: false,
        editCallback: null,
        disableFilter: false,
        disableSort: false,
        hidePagination: false,
        hideActionpanel: false,
        forcePromotion: false,
        specialoffer: false
    };

    componentDidMount() {
        this.ref.current.onScrollEvent = this.onScrollEvent;
        if (this.props?.listId && this.props.mobile && this.props.list?.length) {
            const artikelArray = this.props.list.map((artikel) => {
                let status = store.get('list/' + this.props?.listId + '/' + artikel.artikel + '/');

                if (status === 'green' && (!this?.props?.reduxCart || !this?.props?.reduxCart?.a || !this.props.reduxCart.a[artikel.artikel])) {
                    status = 'grey';
                    store.set('list/' + this.props?.listId + '/' + artikel + '/', 'grey');
                } else if (this?.props?.reduxCart && this?.props?.reduxCart?.a && this?.props?.reduxCart?.a[artikel.artikel]) {
                    status = 'green';
                    store.set('list/' + this.props?.listId + '/' + artikel + '/', 'green');
                }

                if (!status) {
                    status = 'grey';
                }
                return {id: artikel.artikel, status: status};
            });
            this.setState({artikel: artikelArray});
        }
        this.setState({list: this.props?.list}, () => {
            this.scrollTo(document.onscroll);
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps?.listId && nextProps?.list?.length !== (this.props?.list?.length || 0)) {
            const t = [...this.state?.artikel];
            let list;
            if (this.state?.list) {
                list = [...this.state.list];
            } else {
                list = [];
            }
            nextProps?.list?.forEach((a) => {
                if (!this.state?.artikel?.filter((artikel) => artikel.id === a.artikel).length) {
                    t.push(({id: a.artikel, status: 'grey'}));
                    list.push(a);
                    this.seltsame_ref_liste[a.artikel] = React.createRef();
                }
            });
            this.setState({artikel: t, list: list}, () => {
                this.scrollTo(document.onscroll);
            });
        }
    }

    render() {
        const meta = this.props.meta || {};
        const mobile = this.props.mobile || false;
        const medium = this.props.medium || false;
        let pagenumbers = null;
        let mobilePagenumbers = null;
        let count = null;
        let listSorted = [];

        let ordersatzspecialBezeichnung = (this?.props?.settings?.find((e) => e.bezeichnung == 'ordersatzspecialBezeichnung')?.wert || 'false') == 'true';
        let ordersatzspecialArtikel = (this?.props?.settings?.find((e) => e.bezeichnung == 'ordersatzspecialArtikel')?.wert || 'false') == 'true';
        let ordersatzmobilePositionSelect = (this?.props?.settings?.find((e) => e.bezeichnung == 'ordersatzmobilePositionSelect')?.wert || 'grey');

        //hier alle oder max für düsing
        if (this.state?.list?.length) {
            switch (this.state.ppsSetting) {
                case 'alle':
                    break;
                default:
                    count = this.ppsSettings[this.state.displaytype][this.state.ppsSetting];
                    break;
            }

            listSorted = this.state.list;
            if (this.state.textfilter) {
                listSorted = listSorted.filter((product) => {
                    const terms = this?.state?.textfilter?.trim()?.toLowerCase()?.split(' ');
                    return terms.every((term) => {
                        term = term.trim();
                        return (product?.artikel || product?.boerse || '').toString().includes(term) ||
                            (product.bezeichnung || '')?.trim()?.toLowerCase().includes(term);
                    });
                });
            }

            // hier
            if (this.state.filterSelect && mobile && this.props?.listId) {
                listSorted = listSorted.filter((product) => {
                    let className = this.state?.artikel.filter((artikel) => {
                            return artikel.id === product.artikel;
                        }
                    );
                    if (className && className.length > 0) {
                        className = className[0].status;
                    } else {
                        className = '';
                    }
                    return className === this.state?.filterSelect || this.state?.filterSelect === 'alle';
                });
                // DIes sorgt für das neue laden
                // document.onscroll();
            }

            if (!this.props.disableFilter) {
                listSorted = listSorted.filter((a) => {
                    switch (this.state?.filter) {
                        case 'alle':
                            return true;
                        case '#':
                            return [
                                'a',
                                'b',
                                'c',
                                'd',
                                'e',
                                'f',
                                'g',
                                'h',
                                'i',
                                'j',
                                'k',
                                'l',
                                'm',
                                'n',
                                'o',
                                'p',
                                'q',
                                'r',
                                's',
                                't',
                                'u',
                                'v',
                                'w',
                                'x',
                                'y',
                                'z'
                            ].indexOf(a.bezeichnung.charAt(0)?.toLowerCase()) === -1;
                        default:
                            return a.bezeichnung.charAt(0)?.toLowerCase()
                                .localeCompare(this.state.filter, 'de', {sensitivity: 'base'}) === 0;
                    }
                });
            }
            let listLength = listSorted.length;
            const listSetting = this.ppsSettings[this.state.displaytype][this.state.ppsSetting];
            listLength = listLength + (listSetting - (listSorted.length % listSetting));
            if (listLength < (this.state.page * this.ppsSettings[this.state.displaytype][this.state.ppsSetting])) {
                this.setState({page: 1});
            }

            if (!this.props.disableSort || this?.props?.hausmesse) {
                //hier
                const sortby = (a, b) => {
                    switch (this.state.sortby) {
                        case 'vertriebsaktion_sortierschluessel':
                            return a?.vertriebsaktion_sortierchluessel === b?.vertriebsaktion_sortierchluessel
                                ? 0
                                : (a?.vertriebsaktion_sortierchluessel > b?.vertriebsaktion_sortierchluessel ? 1 : -1);
                        case 'hausmesse':
                            let aV = 999999999999999;
                            let bV = 999999999999999;

                            if (a?.messe_sortierung) {
                                aV = a?.messe_sortierung;
                            }
                            if (b?.messe_sortierung) {
                                bV = b?.messe_sortierung;
                            }

                            return aV === bV
                                ? ('' + a.bezeichnung?.toLowerCase()?.trim()).localeCompare(b?.bezeichnung?.toLowerCase()?.trim())
                                : (aV > bV ? 1 : -1);
                        case 'nummer':
                            return (a.artikel || a.boerse) === (b.artikel || b.boerse)
                                ? 0
                                : ((a.artikel || a.boerse) > (b.artikel || b.boerse) ? 1 : -1);
                        case 'preis':
                            const vkpA = a && a.preise && a.preise.vkp ? a.preise.vkp : 0;
                            const vkpB = b && b.preise && b.preise.vkp ? b.preise.vkp : 0;
                            return vkpA === vkpB ? 0 : (vkpA > vkpB ? 1 : -1);
                        case 'eigen':
                            return a.sortierung === b.sortierung
                                ? 0
                                : (a.sortierung > b.sortierung ? 1 : -1);
                        case 'kategorie':
                            const catA = a.category_tree || null;
                            const catB = b.category_tree || null;

                            let aLevel1 = null;
                            let bLevel1 = null;
                            let aLevel2 = {id: 0, bezeichnung: '', sortierschluessel: 0};
                            let bLevel2 = {id: 0, bezeichnung: '', sortierschluessel: 0};

                            if (catA) {
                                aLevel1 = catA[0];
                                if (catA.length > 1) {
                                    aLevel2 = catA[1];
                                }
                            }
                            if (catB) {
                                bLevel1 = catB[0];
                                if (catB.length > 1) {
                                    bLevel2 = catB[1];
                                }
                            }
                            if (!catA && !catB) {
                                return ('' + a.bezeichnung?.toLowerCase()?.trim()).localeCompare(b.bezeichnung?.toLowerCase()?.trim());
                            } else if (catA && !catB) {
                                return -1;
                            } else if (!catA && catB) {
                                return 1;
                            } else {
                                let res;
                                aLevel1 = aLevel1 || {};
                                bLevel1 = bLevel1 || {};
                                if (aLevel1.id === bLevel1.id) {
                                    if (aLevel2.id === bLevel2.id) {
                                        if (a.bezeichnung === b.bezeichnung) {
                                            res = 0;
                                        } else {
                                            res = a.bezeichnung > b.bezeichnung ? 1 : -1;
                                        }
                                    } else {
                                        if (aLevel2.sortierschluessel === bLevel2.sortierschluessel) {
                                            res = aLevel2.id > bLevel2.id ? 1 : -1;
                                        } else {
                                            res = aLevel2.sortierschluessel > bLevel2.sortierschluessel ? 1 : -1;
                                        }
                                    }
                                } else {
                                    if (aLevel1.sortierschluessel === bLevel1.sortierschluessel) {
                                        res = aLevel1.id > bLevel1.id ? 1 : -1;
                                    } else {
                                        res = aLevel1.sortierschluessel > bLevel1.sortierschluessel ? 1 : -1;
                                    }
                                }
                                return res;
                            }
                        case 'bezeichnung':
                        default:
                            return ('' + a.bezeichnung?.toLowerCase()?.trim()).localeCompare(b?.bezeichnung?.toLowerCase()?.trim());
                    }
                };
                if (meta?.conf.ordersatz_highlight && this.props?.listId) {
                    //array aufteile sortieren und dann wieder zusamenfügen

                    let list1 = [];
                    let list2 = [];
                    listSorted.map((e) => {
                        if (e.ordersatz_highlight) {
                            list1.push(e);
                        } else {
                            list2.push(e);
                        }
                    });
                    list1 = list1.sort(sortby);
                    list2 = list2.sort(sortby);
                    if (!this.state.sortasc) {
                        list1 = list1.reverse();
                        list2 = list2.reverse();
                    }
                    listSorted = list1.concat(list2);
                } else {
                    listSorted = listSorted.sort(sortby);
                    if (!this.state.sortasc) {
                        listSorted = listSorted.reverse();
                    }
                }
            }

        }

        let displayList = [];
        if (count === null) {
            displayList = listSorted;
        } else if (listSorted.length) {
            const pages = Math.ceil(listSorted.length / count);
            const start = (this.state.page - 1) * count;
            displayList = listSorted.slice(start, start + count);
            const numbers = [];
            for (let i = 1; i <= pages; i++) {
                ((i) => {
                    numbers.push(
                        <button key={i} className={'pagenumber' + (this.state.page === i ? ' active' : '')}
                                onClick={() => {
                                    this.setState({
                                        page: i
                                    }, () => {
                                        window.location.href = '#_ProductList';
                                        document.onscroll();
                                    });
                                }}>
                            {i}
                        </button>
                    );
                })(i);
            }
            if (pages - this.state.page > 4) {
                numbers.splice(this.state.page + 2, (pages - this.state.page) - 3, '...');
            }
            if (this.state.page > 5) {
                numbers.splice(1, this.state.page - 4, '...');
            }
            pagenumbers = <div className="pagenumbers">
                <button onClick={() => {
                    this.setState({page: Math.max(this.state.page - 1, 1)}, () => {
                        window.location.href = '#_ProductList';
                        document.onscroll();
                    });
                }}>
                    <i className="icon fas fa-chevron-circle-left"/>
                </button>
                {numbers}
                <button onClick={() => {
                    this.setState({page: Math.min(this.state.page + 1, pages)}, () => {
                        window.location.href = '#_ProductList';
                        document.onscroll();
                    });
                }}>
                    <i className="icon fas fa-chevron-circle-right"/>
                </button>
            </div>;
            if (mobile) {
                pagenumbers =
                    this.state.gotoPage ? <div className="gotoPage">
                            <input type="number" placeholder="Gehe zu..." value={this.state.toPage} onClick={(event) => {
                                event.stopPropagation();
                                event.preventDefault();
                            }
                            }
                                   onChange={(e) => {
                                       if (e.target.value <= pages) {
                                           this.setState({toPage: parseInt(e.target.value)});
                                       }
                                   }}/>
                            <button onClick={(event) => {
                                event.stopPropagation();
                                event.preventDefault();
                                if (this.state.toPage) {
                                    this.setState({page: this.state.toPage});
                                }
                                this.setState({gotoPage: false, toPage: ''});
                            }}><i className="icon fas fa-arrow-right"/></button>
                        </div>
                        : <button onClick={(event) => {
                            event.stopPropagation();
                            event.preventDefault();
                            if (pages <= 1) {
                                return;
                            }
                            this.setState({gotoPage: true});
                        }}
                                  className="paginationButton">Seite {this.state.page} von {pages}</button>;
                const lastPage = listSorted.length <= this.ppsSettings[this.state.displaytype][this.state.ppsSetting] * this.state.page;

                mobilePagenumbers = <div className="mobile-pagenumbers">

                    <button disabled={this.state.page === 1} onClick={() => {
                        this.setState({page: (this.state.page - 1)}, () => {
                            window.location.href = '#_ProductList';
                            document.onscroll();
                        });
                    }}>{this.state.page === 1 ? '' : <><i
                        className="icon fas fa-arrow-left"/>{' Seite ' + (this.state.page - 1)}</>}
                    </button>
                    <button disabled={lastPage} onClick={() => {
                        this.setState({page: (this.state.page + 1)}, () => {
                            window.location.href = '#_ProductList';
                            document.onscroll();
                        });
                    }}>{lastPage ? '' : <>
                        {'Seite ' + (this.state.page + 1) + ' '}<i
                        className="icon fas fa-arrow-right"/>
                    </>}
                    </button>
                    <button className="firstLastPage" disabled={this.state.page === 1} onClick={() => {
                        this.setState({page: 1}, () => {
                            window.location.href = '#_ProductList';
                            document.onscroll();
                        });
                    }}>{this.state.page === 1 ? '' : <><i
                        className="icon fas fa-arrow-left"/>{' Erste Seite '}</>}
                    </button>
                    <button className="firstLastPage" disabled={lastPage} onClick={() => {
                        this.setState({page: pages}, () => {
                            window.location.href = '#_ProductList';
                            document.onscroll();
                        });
                    }}>{lastPage ? '' : <>{' Letzte Seite '}<i
                        className="icon fas fa-arrow-right"/></>}
                    </button>
                </div>;

                if (listSorted.length < this.ppsSettings[this.state.displaytype][this.state.ppsSetting]) {
                    mobilePagenumbers = null;
                }
            }
        }

        let products;
        if (displayList.length) {
            products = [];
            const categories = [];

            displayList.forEach((product, key) => {
                const status = this.state?.artikel?.filter((a) => a.id === product.artikel)[0]?.status;

                if (!meta.fallbackWarengruppe && this.state.sortby === 'kategorie' && this.state.displaytype !== 'ordsatz') {
                    if (product && product.category_tree && product.category_tree.length) {
                        const level1 = product.category_tree[0];
                        let level2 = null;
                        if (product.category_tree.length > 1) {
                            level2 = product.category_tree[1];
                        }
                        const cat = level2 && level2.id ? level2 : level1;
                        if (cat && cat.id && categories.indexOf(cat.id) < 0 && (!status || status === 'grey')) {
                            categories.push(cat.id);
                            let kategorieBezeichnung = level1.bezeichnung;
                            if (level2 && level2.bezeichnung) {
                                kategorieBezeichnung = kategorieBezeichnung + ' > ' + level2.bezeichnung;
                            }

                            if (!mobile) {
                                products.push(
                                    <h3 key={`divider_${cat.id}`} className={'category-divider'}>
                                        <a href={(this.props?.meta?.conf?.cssCompletePath
                                                ? this.props?.meta?.hostname
                                                : '') + '/category/' + cat.id + '/' +
                                            venditshop.helper.stripStringForUrl(cat.bezeichnung) + '/'}>
                                            {kategorieBezeichnung}
                                        </a>
                                    </h3>
                                );
                            }

                        }
                    } else {
                        const dummy = -1;
                        if (dummy && categories.indexOf(dummy) < 0) {
                            categories.push(dummy);
                            const kategorieBezeichnung = 'Sonstige';
                            products.push(
                                <h3 key={'category-divider-sonstige'} className="category-divider">
                                    <a>
                                        {kategorieBezeichnung}
                                    </a>
                                </h3>);
                        }
                    }
                }

                if (this.state.displaytype === 'ordsatz') {
                    products.push(
                        <Product
                            key={`${product.artikel || 0}_${product.boerse || 0}_${product.bezeichnung || ''}_${key}`}
                            {...product} hideImg hrefPrefix={this.props.hrefPrefix} size={this.state.displaytype}
                            listId={this.props?.listId} forcePromotion={this.props.forcePromotion}
                            settings={this?.props?.settings}
                            specialoffer={this.props.specialoffer}
                            anbruch_zulassen={this?.props?.anbruch_zulassen || 0}/>
                    );
                } else {
                    let className = this.state.artikel.filter((artikel) => {
                            return artikel.id === product.artikel;
                        }
                    );
                    if (className && className.length > 0) {
                        className = className[0].status;
                    } else {
                        className = '';
                    }
                    let classNameWrap = this.state.shouldhide[product.artikel] || '';

                    classNameWrap += (this.state.filterSelect == 'alle' ? ' tmp ' : '');

                    if (this.state.shouldhide[product.artikel] === 'hidden-right') {
                        window.setTimeout(() => {
                            const tmp = this.state.artikel;
                            tmp.map((a) => {
                                if (a.id === product.artikel) {
                                    a.status = 'green';
                                }
                            });
                            const shouldHideArray = this.state.shouldhide;
                            shouldHideArray[product.artikel] = '';
                            this.setState({shouldhide: shouldHideArray, artikel: tmp});
                            this.forceUpdate();
                        }, 500);
                    } else if (this.state.shouldhide[product.artikel] === 'hidden-left') {
                        window.setTimeout(() => {
                            const tmp = this.state.artikel;
                            tmp.map((a) => {
                                if (a.id === product.artikel) {
                                    a.status = 'red';
                                }
                            });
                            const shouldHideArray = this.state.shouldhide;
                            shouldHideArray[product.artikel] = '';
                            this.setState({shouldhide: shouldHideArray, artikel: tmp});
                            this.forceUpdate();
                        }, 500);
                    }

                    const threshold = Math.min(window.innerWidth / 3, 100);

                    let ordersatzDisplayCart = null;
                    let ordersatzDisplayDelete = null;
                    if (mobile && this.props?.listId) {
                        ordersatzDisplayCart = <div
                            className={'ordersatzDisplay-Cart ' +
                                (this.state.ordersatzDisplay === 'cart' && product.artikel === this.state.currentSwipingArtikel
                                    ? 'active' : '')}>
                            <i className="icon fas fa-shopping-cart"/>
                        </div>;
                        ordersatzDisplayDelete = <div
                            className={'ordersatzDisplay-Delete ' +
                                (this.state.ordersatzDisplay === 'delete' && product.artikel === this.state.currentSwipingArtikel
                                    ? 'active' : '')}>
                            <i className="icon fas fa-trash-alt"/>
                        </div>;
                    }
                    // Nicht bestellbarte Artikel werden im mobilen Ordersaz nicht mehr dargestellt
                    if (!product.bestellbar && this.props?.listId && mobile && !meta?.conf?.displayAllProductsinOrdersatzMobile) {
                        return;
                    }

                    if (product?.art === 'Text') {
                        products.push(<P1>{product.text}</P1>);
                    } else if (product?.art === 'Header') {
                        products.push(<h3>{product.text}</h3>);
                    } else if (product?.art === 'PDF') {
                        let file = product.url.replace(/^.*[\\\/]/, '');
                        let url = '/download/messe/' + this?.props?.hausmesse + '/hersteller/' + product.kreditor + '/' + file;
                        products.push(<a className={'hausmesseLink'} href={url} download={file}><i
                            className="fas fa-file-pdf"></i> {product?.text ? product?.text : product?.url}
                        </a>);
                    } else if (product?.art === 'URL') {
                        products.push(<a className={'hausmesseLink'} href={product?.url} target='_blank'><i
                            className="fas fa-external-link-alt"></i> {product?.text ? product?.text : product?.url}
                        </a>);
                    } else if (product?.art === 'Video') {
                        products.push(<a className={'hausmesseLink'} href={product?.url} target='_blank'><i
                            className="fas fa-play-circle"></i> {product?.text ? product?.text : product?.url}</a>);
                    } else if (product?.art === 'Grafik') {
                        products.push(<a className={'hausmesseLink'} href={product?.url} target='_blank'><i
                            className="icon fas fa-image"/> {product?.text ? product?.text : product?.url}</a>);
                    } else {
                        let styles = null;
                        if(meta?.licenseCache?.artikelhervorheben && product?.hervorheben){
                            console.log('this.state.displaytype');
                            console.log(this.state.displaytype);
                            if(product?.background_color_hex){
                                if(this.state.displaytype=='tabelle'){
                                    styles = {
                                        color: (product?.font_color == 1 ? 'white': 'black'),
                                        background: `linear-gradient(to right top, ${product?.background_color_hex}, rgba(255, 255, 255, 0.7)) `,
                                    };
                                }else{
                                    styles = {
                                        color: (product?.font_color == 1 ? 'white': 'black'),
                                        background: `linear-gradient(to left bottom, ${product?.background_color_hex}, rgba(255, 255, 255, 0.7))`,
                                    };
                                }
                            }
                        }
                        products.push(
                            <div
                                key={`${product.artikel || 0}_${product.boerse || 0}_${product.bezeichnung || ''}_${this.props?.listId
                                    ? this.props?.listId
                                    : key}`}
                                style={styles}
                                className={'product-wrap ' + classNameWrap+ ' '+(meta?.licenseCache?.artikelhervorheben && product?.hervorheben
                                ? 'hervorheben' : null)}>
                                {ordersatzDisplayCart}
                                <ReactSwipeEvents
                                    className={'product ' + (this.props?.listId ? 'ordsatz ' : '') +
                                        className + ' ' +
                                        (this.state.ordersatzDisplay !== 'none' && product.artikel === this.state.currentSwipingArtikel
                                            ? this.state.ordersatzDisplay : '')}
                                    onSwipedLeft={
                                        () => {
                                            if (!this.props?.listId || !mobile || (new Date().getTime() < this.state.lastScrollTime + 500)) {
                                                return;
                                            }
                                            if (this.state.ordersatzDisplay !== 'none') {
                                                this.swipeleft(product.artikel);
                                                this.setState({currentSwipingArtikel: 0, ordersatzDisplay: 'none'});
                                            }
                                        }
                                    }

                                    onSwipedRight={
                                        () => {
                                            //hier
                                            if (!this.props?.listId || !mobile
                                                || !product.bestellbar
                                                || (new Date().getTime() < this.state.lastScrollTime + 500)
                                                || !(this.seltsame_ref_liste[product.artikel]?.current?.input_ref?.current?.state?.menge)
                                            ) {
                                                return;
                                            }
                                            if (this.state.ordersatzDisplay !== 'none') {
                                                this.swiperight(product.artikel);
                                                this.setState({currentSwipingArtikel: 0, ordersatzDisplay: 'none'});
                                            }
                                        }
                                    }

                                    onSwiping={(e, originalX, originalY, currentX, currentY, deltaX, deltaY) => {
                                        if (!this.props?.listId || !mobile || (new Date().getTime() < this.state.lastScrollTime + 500)) {
                                            this.setState({ordersatzDisplay: 'none'});
                                            return;
                                        }
                                        this.setState({currentSwipingArtikel: product.artikel});
                                        if (deltaX > threshold && product.bestellbar) {
                                            //Die Menge 0 soll nicht nach rehcte geswiped werden
                                            if (!(this.seltsame_ref_liste[product.artikel]?.current?.input_ref?.current?.state?.menge)
                                            ) {
                                                return;
                                            }
                                            this.setState({ordersatzDisplay: 'cart'});
                                        } else if (deltaX < (threshold * (-1))) {
                                            this.setState({ordersatzDisplay: 'delete'});
                                        } else {
                                            this.setState({ordersatzDisplay: 'none'});
                                        }
                                    }
                                    }
                                    threshold={threshold}>
                                    <Product {...product}
                                             ref={this.seltsame_ref_liste[product.artikel]}
                                             anbruch_zulassen={this?.props?.anbruch_zulassen || 0}
                                             settings={this?.props?.settings}
                                             removeFromList={this.removeFromList}
                                             hideImg={this.state.displaytype === 'tabelle' ||
                                                 this.state.displaytype === 'ordsatz' ||
                                                 this.state.displaytype === 'defaultNoImg'}
                                             hrefPrefix={this.props.hrefPrefix}
                                             liefertage={this?.props?.liefertage}
                                             size={this.state.displaytype === 'defaultNoImg' ? 'default' : this.state.displaytype}
                                             listId={this.props?.listId}
                                             forcePromotion={this.props.forcePromotion}
                                             specialoffer={this.props.specialoffer}
                                             hausmesse={this?.props?.hausmesse}
                                             vertriebsaktion={this?.props?.vertriebsaktion}
                                    />
                                </ReactSwipeEvents>
                                {ordersatzDisplayDelete}
                            </div>
                        );
                    }
                }
            });
        } else {
            products = <div className="error" style={{lineHeight: '30px'}}>Keine Produkte vorhanden</div>;
        }

        let ordersatzSpezialansichtButton = null;
        if (this.props.ordersatzSpezialansicht) {
            ordersatzSpezialansichtButton =
                <button className={'displaytype' + (this.state.displaytype === 'ordsatz' ? ' active' : '')}
                        onClick={() => this.setDisplaytype('ordsatz')}>
                    <i className="icon fas fa-table"/>
                </button>;
        }
        let editBtn = null;
        if (this.props.editable && this.props.editCallback && typeof this.props.editCallback === 'function') {
            editBtn = <button className="edit-btn" onClick={this.props.editCallback}>Liste bearbeiten</button>;
        }
        let pagination = null;
        if (!this.props.hidePagination) {
            let alleButton = null;
            if (this.props.list && (this.props.list.length < 500)) {
                alleButton = <button className={'pps_setting' + (
                    this.state.ppsSetting === 'alle' ? ' active' : '')}
                                     onClick={() => this.setPpsSetting('alle')}>alle</button>;
            }

            const setting = this.ppsSettings[this.state.displaytype];
            let ansichtsarten = <>
                <button className={'displaytype' + (this.state.displaytype === 'galerie' ? ' active' : '')}
                        onClick={() => this.setDisplaytype('galerie')}>
                    <i className="icon fas fa-th-large"/>
                </button>
                <button className={'displaytype' + (this.state.displaytype === 'liste' ? ' active' : '')}
                        onClick={() => this.setDisplaytype('liste')}>
                    <i className="icon fas fa-th-list"/>
                </button>
                <button className={'displaytype' + (this.state.displaytype === 'tabelle' ? ' active' : '')}
                        onClick={() => this.setDisplaytype('tabelle')}>
                    <i className="icon fas fa-list"/>
                </button>
                {ordersatzSpezialansichtButton}
            </>;

            if (mobile) {
                ansichtsarten = <>
                    <button className={'displaytype' + (this.state.displaytype === 'galerie' ? ' active' : '')}
                            onClick={() => this.setDisplaytype('galerie')}>
                        <i className="icon fas fa-th-large"/>
                    </button>
                    <button className={'displaytype' + (this.state.displaytype === 'defaultNoImg' ? ' active' : '')}
                            onClick={() => this.setDisplaytype('defaultNoImg')}>
                        <i className="icon fas fa-th-list"/>
                    </button>
                </>;

                if (this.props?.listId) {
                    ansichtsarten = <>
                        <button className={'displaytype' + (this.state.displaytype === 'default' ? ' active' : '')}
                                onClick={() => this.setDisplaytype('default')}>
                            <i className="icon fas fa-th-large"/>
                        </button>
                        <button className={'displaytype' + (this.state.displaytype === 'defaultNoImg' ? ' active' : '')}
                                onClick={() => this.setDisplaytype('defaultNoImg')}>
                            <i className="icon fas fa-th-list"/>
                        </button>
                        {ordersatzSpezialansichtButton}
                    </>;
                }
            }
            const artikel_pro_seite = <>
                &nbsp;Artikel pro Seite:
                <button className={'pps_setting' + (this.state.ppsSetting === 'wenig' ? ' active' : '')}
                        onClick={() => this.setPpsSetting('wenig')}>
                    {setting?.wenig}
                </button>
                <button className={'pps_setting' + (this.state.ppsSetting === 'mittel' ? ' active' : '')}
                        onClick={() => this.setPpsSetting('mittel')}>
                    {setting?.mittel}
                </button>
                <button className={'pps_setting' + (this.state.ppsSetting === 'viel' ? ' active' : '')}
                        onClick={() => this.setPpsSetting('viel')}>
                    {setting?.viel}
                </button>
                <button className={'pps_setting' + (this.state.ppsSetting === 'ultra' ? ' active' : '')}
                        onClick={() => this.setPpsSetting('ultra')}>
                    {setting?.ultra}
                </button>
                {alleButton}
            </>;
            if (this?.props?.hideAnsichtsarten) {
                ansichtsarten = null;
            }
            pagination = <div className="pagination">
                {ansichtsarten}
                {artikel_pro_seite}
                {pagenumbers}
            </div>;

            if (mobile) {
                pagination =
                    <div className={'pagination ' + (this.props?.ordersatzSpezialansicht
                        ? 'ordsatzSpezial '
                        : '') + (this.props?.hausmesse ? 'hausmesse' : '')}>
                        {this?.props?.listId ? editBtn : null}
                        {ansichtsarten}
                        {pagenumbers}
                    </div>;
            }
        }

        let actionPanel = null;
        let mobile_sortbyeigen = null;
        let mobile_sortbycategory = null;
        let mobile_sortByVertriebsaktionSortierschluessel = null;
        if (!this.props.hideActionpanel) {
            let sortbyEigenButton = null;
            let sortbyCategoryButton = null;
            let sortbyVertriebsaktionSortierschluessel = null;
            let widthClass = 'w33';
            if (this.props.sortByVertriebsaktionSortierschluessel) {
                widthClass = 'w25';
                sortbyVertriebsaktionSortierschluessel =
                    <button
                        className={(this.state.sortby === 'vertriebsaktion_sortierschluessel' ? 'active ' : '') + widthClass}
                        onClick={() => this.setSortby('vertriebsaktion_sortierschluessel')}>Ihre Sortierung&nbsp;<i
                        className={'icon fas fa-chevron-' + (this.state.sortasc ? 'down' : 'up')}/>
                    </button>;
                mobile_sortByVertriebsaktionSortierschluessel =
                    <option value="vertriebsaktion_sortierschluessel">Sortierschlüssel</option>;
            } else if (this.props.sortByEigen && this.props.sortByCategory) {
                if (!meta.fallbackWarengruppe) {
                    widthClass = 'w20';
                    sortbyCategoryButton =
                        <button className={(this.state.sortby === 'kategorie' ? 'active ' : '') + widthClass}
                                onClick={() => this.setSortby('kategorie')}>Kategorie&nbsp;<i
                            className={'icon fas fa-chevron-' + (this.state.sortasc ? 'down' : 'up')}/>
                        </button>;
                } else {
                    widthClass = 'w25';
                }
                sortbyEigenButton = <button className={(this.state.sortby === 'eigen' ? 'active ' : '') + widthClass}
                                            onClick={() => this.setSortby('eigen')}>Ihre Sortierung&nbsp;<i
                    className={'icon fas fa-chevron-' + (this.state.sortasc ? 'down' : 'up')}/>
                </button>;
                mobile_sortbyeigen = <option value="eigen">Eigene Sortierung</option>;
                mobile_sortbycategory = <option value="kategorie">Kategorie</option>;
            } else if (this.props.sortByEigen) {
                widthClass = 'w25';
                sortbyEigenButton = <button className={(this.state.sortby === 'eigen' ? 'active ' : '') + widthClass}
                                            onClick={() => this.setSortby('eigen')}>Ihre Sortierung&nbsp;<i
                    className={'icon fas fa-chevron-' + (this.state.sortasc ? 'down' : 'up')}/>
                </button>;
                mobile_sortbyeigen = <option value="eigen">Eigene Sortierung</option>;
            } else if (this.props.sortByCategory) {
                if (!meta.fallbackWarengruppe) {
                    widthClass = 'w25';
                    sortbyCategoryButton =
                        <button className={(this.state.sortby === 'kategorie' ? 'active ' : '') + widthClass}
                                onClick={() => this.setSortby('kategorie')}>Kategorie&nbsp;<i
                            className={'icon fas fa-chevron-' + (this.state.sortasc ? 'down' : 'up')}/>
                        </button>;
                    mobile_sortbycategory = <option value="kategorie">Kategorie</option>;
                } else {
                    widthClass = 'w33';
                }
            }

            const buttonSortByPreis = null;

            if (mobile) {
                let fourthpart;


                if (this.props?.listId) {
                    fourthpart = <select className="ordersatzFilter" onChange={async (e) => {
                        this.setState({filterSelect: e.target.value}, document.onscroll);
                        if (meta?.licenseCache?.customersettings) {
                            this.props?.changeLoading(true);
                            await this.saveSetting(e.target.value, 'ordersatzmobilePositionSelect');
                            this.props?.changeLoading(false);
                        }
                    }} defaultValue={ordersatzmobilePositionSelect}>

                        <option value="grey">offene Positionen</option>
                        <option value="green">bestellte Positionen</option>
                        <option value="red">verworfene Positionen</option>
                        <option value="alle">alle Positionen</option>
                    </select>;
                }

                actionPanel = <div className="action-panel-mobile">
                    <select onChange={(e) => this.setSortby(e.target.value)} value={this.state.sortby}
                            className={(this.props.disableSort ? 'hideSort' : '')}>
                        {mobile_sortByVertriebsaktionSortierschluessel}
                        <option value="bezeichnung">Bezeichnung</option>
                        <option value="nummer">Nummer</option>
                        {mobile_sortbycategory}
                        {mobile_sortbyeigen}
                    </select>

                    <select className={(this.props.disableSort ? 'hideSort' : '')}
                            value={this.state.sortasc ? 'up' : 'down'}
                            onChange={(e) => {
                                this.setState({sortasc: e.target.value == 'up'}, this.setSortby(this.state.sortby, e.target.value == 'up'));
                            }}>
                        <option value="up">Aufsteigend</option>
                        <option value="down">Absteigend</option>
                    </select>
                    <div className={'filtern'}>
                        <input ref={this.focusRef} type="text" placeholder="Filtern..." value={this.state.textfilter}
                               onChange={this.handleChangeTextfilter}/>
                        <button onClick={() => {
                            this.setState({textfilter: ''});
                            if (this.focusRef.current) {
                                this.focusRef.current.focus();
                            }
                        }
                        }><i className="icon fas fa-times"/>
                        </button>
                    </div>
                    {fourthpart}
                    <p className={'alphaMobileFilter'}>Anfangsbuchstabe:</p>
                    <select className="filter-alpha" onChange={async (e) => {
                        this.setState({filter: e.target.value}, document.onscroll);
                    }}>
                        {
                            [
                                'alle',
                                '#',
                                'a',
                                'b',
                                'c',
                                'd',
                                'e',
                                'f',
                                'g',
                                'h',
                                'i',
                                'j',
                                'k',
                                'l',
                                'm',
                                'n',
                                'o',
                                'p',
                                'q',
                                'r',
                                's',
                                't',
                                'u',
                                'v',
                                'w',
                                'x',
                                'y',
                                'z'
                            ].map((filter) => <option key={filter} value={filter}>{filter}</option>)
                        }
                    </select>
                </div>;
            } else {
                actionPanel = <div className={'action-panel'}>
                    <div className={'sort ' + (this.props.disableSort ? 'hideSort' : '')}>
                        <div className={widthClass}>Sortieren nach:</div>
                        <button className={(this.state.sortby === 'bezeichnung' ? 'active ' : '') + widthClass}
                                onClick={() => this.setSortby('bezeichnung')}>Bezeichnung&nbsp;<i
                            className={'icon fas fa-chevron-' + (this.state.sortasc ? 'down' : 'up')}/>
                        </button>
                        {buttonSortByPreis}
                        <button className={(this.state.sortby === 'nummer' ? 'active ' : '') + widthClass}
                                onClick={() => this.setSortby('nummer')}>Nummer&nbsp;<i
                            className={'icon fas fa-chevron-' + (this.state.sortasc ? 'down' : 'up')}/>
                        </button>
                        {sortbyCategoryButton}
                        {sortbyEigenButton}
                        {sortbyVertriebsaktionSortierschluessel}
                    </div>
                    <div className="filter-alpha">
                        {
                            [
                                'alle',
                                '#',
                                'a',
                                'b',
                                'c',
                                'd',
                                'e',
                                'f',
                                'g',
                                'h',
                                'i',
                                'j',
                                'k',
                                'l',
                                'm',
                                'n',
                                'o',
                                'p',
                                'q',
                                'r',
                                's',
                                't',
                                'u',
                                'v',
                                'w',
                                'x',
                                'y',
                                'z'
                            ].map((filter) => <button key={filter} className={(
                                this.state.filter === filter ? 'active' : '')}
                                                      onClick={() => this.setState({filter: filter}, document.onscroll)}>{filter}</button>)
                        }
                    </div>
                    <div className="text-filter">
                        <input ref={this.focusRef} type="text" placeholder="Diese Liste durchsuchen..."
                               value={this.state.textfilter}
                               onChange={this.handleChangeTextfilter}/>
                        <button className={'clearbutton'} onClick={() => {
                            this.setState({textfilter: ''});
                            if (this.focusRef.current) {
                                this.focusRef.current.focus();
                            }
                        }
                        }><i className="icon far fa-times"/>
                        </button>
                    </div>
                </div>;
            }
        }

        let shortcutCart = null;
        if (this.props.shortcutCart) {
            shortcutCart = <a className="shortcut-cart" href="/cart/">zum Warenkorb</a>;
        }

        const btnArea = <div className="btn-area">{editBtn}{shortcutCart}</div>;

        let clear = null;
        if (this.props.list && this.props.list.length) {
            clear = <Clear className={this.state.displaytype}/>;
        }

        let productsWrap = products;
        if (this.state.displaytype === 'ordsatz') {

            const ldat1 = venditshop.helper.formatDateShort(new Date(this.props.ordersatzLieferdatum1));
            const ldat2 = venditshop.helper.formatDateShort(new Date(this.props.ordersatzLieferdatum2));
            const ldat3 = venditshop.helper.formatDateShort(new Date(this.props.ordersatzLieferdatum3));
            const ldat4 = venditshop.helper.formatDateShort(new Date(this.props.ordersatzLieferdatum4));
            const ldat5 = venditshop.helper.formatDateShort(new Date(this.props.ordersatzLieferdatum5));

            productsWrap = <table style={{width: '100%'}}>
                <thead>
                <tr>
                    {ordersatzspecialArtikel ? <th>Artikel</th> : null}
                    {ordersatzspecialBezeichnung ? <th className={'bezeichnung'}>Bezeichnung</th> : null}
                    <th className="right">{ldat5}</th>
                    <th className="right">{ldat4}</th>
                    <th className="right">{ldat3}</th>
                    <th className="right">{ldat2}</th>
                    <th className="right">{ldat1}</th>
                    <th className="right">Ø</th>
                    <th className="w200">Menge</th>
                </tr>
                </thead>
                <tbody>
                {products}
                </tbody>
            </table>;
        }
        let uebernahmeMobile = null;
        if (mobile && this.props?.listId) {
            uebernahmeMobile = <div className="uebernahme">
                <button className="bestellen" onClick={() => {
                    this.props?.changeLoading(true);
                    window.location.href = '/cart/';
                }}>Zum Warenkorb
                </button>
            </div>;
        }

        let zurMesseButton = null;
        if (this?.props?.hausmesse) {
            zurMesseButton =
                <a className="hausmesseButton" href={'/hausmesse/' + this?.props?.hausmesse + '/'}>Zurück zur
                    Hausmesse</a>;
        }

        const bezeichnung = this.props.bezeichnung + (this.props.list ? ' (' + (this.props.list.length || 0) + ')' : '');
        return <div ref={this.ref} className={'_ProductList '} id="_ProductList"
                    onClick={() => this.setState({gotoPage: false})}
        >
            {!mobile ? btnArea : null}
            {!mobile ? pagination : null}
            {!bezeichnung.includes('undefined') && !this?.props?.noHeader ? <h3>{bezeichnung}</h3> : null}
            {mobile ? pagination : null}
            {actionPanel}
            <div className={(this.state.displaytype === 'defaultNoImg'
                ? 'default'
                : this.state.displaytype) + (this.props?.listId ? ' ordSatz' : '')}>
                {productsWrap}
            </div>
            {zurMesseButton}
            {clear}
            {mobile ? mobilePagenumbers : pagination}
            {!mobile ? btnArea : null}
            {uebernahmeMobile}
        </div>;
    }
}

export default ReactRedux.connect((state) => ({
    meta: state.meta,
    mobile: state.mobile.isMobile,
    medium: state.mobileMedium.isMedium,
    reduxCart: state.cart
}), (dispatch) => ({
    changeLoading: (loading) => {
        dispatch(receiveLoadingUpdate(loading));
    }
}), null, {forwardRef: true})(ProductList);
